import { useCallback, useMemo, useState } from 'react'

import { useAllUsers } from 'common/hooks/useUsers'

type User = ReturnType<typeof useAllUsers>['users'][number]

export const useApprovers = ({
  approverUserIds,
  onChange,
  filterUser
}: {
  approverUserIds: string[]
  onChange: (next: string[]) => void
  filterUser?: (user: User) => boolean
}) => {
  const { users, isPending } = useAllUsers()
  const [multiSelectKey, setMultiSelectKey] = useState(0)

  const userOptions = useMemo(() => {
    const filtered = filterUser ? users.filter(filterUser) : users
    return filtered.map(user => ({ label: user.email, value: user.id }))
  }, [users, filterUser])

  const approvers = useMemo(() => {
    return approverUserIds.flatMap(userId => {
      const user = users.find(u => u.id === userId)
      return user ? [{ id: userId, email: user.email }] : []
    })
  }, [users, approverUserIds])

  const removeApprover = useCallback(
    (userId: string) => {
      onChange(approverUserIds.filter(id => id !== userId))
      setMultiSelectKey(k => k + 1)
    },
    [approverUserIds, onChange]
  )

  return {
    userOptions,
    approvers,
    isPending,
    multiSelectKey,
    removeApprover
  }
}
